import { render, staticRenderFns } from "./showExcludedComponent.vue?vue&type=template&id=4e4a6a18&scoped=true&"
import script from "./showExcludedComponent.ts?vue&type=script&lang=js&"
export * from "./showExcludedComponent.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4a6a18",
  null
  
)

export default component.exports